import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Dropdown from 'react-bootstrap/Dropdown'; // Import Dropdown component
import './megamenu.css';

function BasicExample(props) {
  const { showNav, setShowNav } = props;
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  
  function toggleNav() {
    setShowNav(!showNav);
  }

  function handleMouseEnter(eventKey) {
    setHoveredDropdown(eventKey);
  }

  function handleMouseLeave() {
    setHoveredDropdown(null);
  }

  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container className='sidebar'>
        <Navbar.Brand aria-label='Narbar Home' href="#home">{""}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleNav} />
        <Navbar.Collapse id="basic-navbar-nav" className={!showNav && ' d-none'}>
          <Nav className="newDD me-auto">

            {/* 1. Home */}
            <Nav.Item className="nav-link">
              <Link to='/' role='button' >
                <i className='fas fa-home'></i>
              </Link>
            </Nav.Item>



            {/**************** 2. Institute ***************/}

            <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll"
              onMouseEnter={() => handleMouseEnter("institute")}
              onMouseLeave={handleMouseLeave}
              show={hoveredDropdown === "institute"}
              title="Institute"
            >
              {/* <span className="nav-link">Institute</span> */}
              {hoveredDropdown === "institute" && (
              <div className="eventsNav ">
                {/* <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s"> */}
                  <div className='has-border '>
                    
                    <Dropdown.Header>About IITT</Dropdown.Header>
                    <Link to="/aboutus" className="dropdown-item nav-link">About Us</Link>
                    {/* <Link to="/mission-vision" className="dropdown-item nav-link">Vision & Mission</Link> */}
                    <Link to="/permanent-campus" className="dropdown-item nav-link">Campus Map </Link>
                    <Link to="/newsletter" className="dropdown-item nav-link">IITT Newsletter </Link>
                  </div>
                  <div className='has-border'>
                    <Dropdown.Header>Administration</Dropdown.Header>
                    <Link to="/board-of-governors" className="dropdown-item nav-link">Board of Governors</Link>
                    <Link to="/acad-admin" className="dropdown-item nav-link">Academic Administration</Link>
                    <Link to="/senate" className="dropdown-item nav-link">Senate</Link>
                    <Link to="/finance-committee" className="dropdown-item nav-link">Finance Committee</Link>
                    <Link to="/building-and-work-commitee" className="dropdown-item nav-link">Building & Works Committee</Link>
                    <Link to="/organizational-structure" className="dropdown-item nav-link">Organizational Structure</Link>
                    <Link to="/rti" className="dropdown-item nav-link">RTI</Link>
                    <Link to="/committees" className="dropdown-item nav-link">Committees</Link>
                    {/* <Link to="/internalcomplaintcommittee" className="dropdown-item nav-link">Internal Complaints Committee</Link>
                    <Link to="/liaison-officers" className="dropdown-item nav-link">SC/ST/OBC Liaison Officers/Cell</Link> */}
                  </div>

                  <div className='has-border'>
                    <Dropdown.Header>Reports</Dropdown.Header>
                    <Link to="/annualreports" className="dropdown-item nav-link">Audit & Annual Reports</Link>
                    <Link to="/rti-section-4" className="dropdown-item nav-link">Act and Statutes</Link>
                    {/* <Link to="/policies" className="dropdown-item nav-link">Quality Policy</Link> */}
                    {/* Add other links */}
                  </div>
                  {/* Add other dropdown sections */}
                </div>
              )}
            </NavDropdown>

           

            {/**************** 3. Academics ***************/}

            <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll needScrollTablet"
              onMouseEnter={() => handleMouseEnter("Academics")}
              onMouseLeave={handleMouseLeave}
              show={hoveredDropdown === "Academics"}
              title="Academics"
            >
              {/* <span className="nav-link">Academics</span> */}

                {hoveredDropdown === "Academics" && (
                // <div className="eventsNav  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                <div className="eventsNav ">
                  {/* <div className='has-border'>
                    <Dropdown.Header>Admissions</Dropdown.Header>
                    <Link to="/admissions" className="dropdown-item nav-link">Admissions</Link>
                    <Link to="/ph-d-admission" className="dropdown-item nav-link">Ph.D.</Link>
                    <Link to="/ms-admission" className="dropdown-item nav-link">M.S. (Research)</Link>
                    <Link to="/ms-phd-international" className="dropdown-item nav-link">M.S./Ph.D. International</Link>
                    <Link to="/m-tech-admission" className="dropdown-item nav-link">M.Tech</Link>
                    <Link to="/m-sc-admission" className="dropdown-item nav-link">M.Sc</Link>
                    <Link to="/master-of-public-policy-mpp-admission" className="dropdown-item nav-link">Master of Public Policy (MPP)</Link>
                    <Link to="/b-tech-admission" className="dropdown-item nav-link">B.Tech</Link>
                  </div> */}
                  <div className='has-border'>
                    <Dropdown.Header>Departments</Dropdown.Header>
                    <Link to="https://chemical.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Chemical Engineering</Link>
                    <Link to="https://cy.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Chemistry</Link>
                    <Link to="https://cee.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Civil & Environmental Engineering</Link>
                    <Link to="https://cse.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Computer Science & Engineering</Link>
                    <Link to="https://ee.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Electrical Engineering</Link>
                    <Link to="https://hss.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Humanities and Social Sciences</Link>
                    <Link to="https://mast.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Mathematics & Statistics</Link>
                    <Link to="https://mech.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Mechanical Engineering</Link>
                    <Link to="https://physics.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">Physics</Link>
                  </div>
                  <div className='has-border'>
                    <Dropdown.Header>Program</Dropdown.Header>
                    <Link to="/admissions" className="dropdown-item nav-link">Admissions</Link>
                    <Link to="/phd" className="dropdown-item nav-link">Ph.D.</Link>
                    <Link to="/ms" className="dropdown-item nav-link">M.S. (Research)</Link>
                    <Link to="/mtech" className="dropdown-item nav-link">M.Tech</Link>
                    <Link to="/msc" className="dropdown-item nav-link">M.Sc</Link>
                    <Link to="/master-of-public-policy-mpp" className="dropdown-item nav-link">Master of Public Policy (MPP)</Link>
                    <Link to="/btech" className="dropdown-item nav-link">B.Tech</Link>
                    <Link to="/ms-phd-international" className="dropdown-item nav-link">M.S./Ph.D. International</Link>
                    <Link to="/m-tech-international" className="dropdown-item nav-link">M.Tech International</Link>
                    {/* </div>
                    <div className='has-border'> */}
                    
                    {/* <Link to='https://www.onlinesbi.sbi/sbicollect/icollecthome.htm?corpID=646389' className="dropdown-item nav-link">Fee Payment</Link> */}
                  </div>
                  
                  <div className='has-border'>
                    <Dropdown.Header>Scholarships</Dropdown.Header>
                    <Link to='/institute-scholarships' className="dropdown-item nav-link">Institute Scholarships</Link>
                    <Link to='https://scholarships.gov.in/' target='_blank' className="dropdown-item nav-link">National Scholarship Portal</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Scholarship Calendar <i className="fas fa-uc"></i></Link> */}
                    <Link to='/bonafides-scholarship-forms' className="dropdown-item nav-link">Bonafides & Scholarship Forms</Link>
                    {/* </div>
                    <div className='has-border'> */}
                    <Dropdown.Header>Other Fellowships</Dropdown.Header>
                    <Link to='https://www.ugc.gov.in/pdfnews/8821047_revised-JRF.pdf' target='_blank' className="dropdown-item nav-link">UGC Guidelines</Link>
                    <Link to='https://csirhrdg.res.in/Home/Index/1/Default/2971/60' target='_blank' className="dropdown-item nav-link">CSIR Guidelines</Link>
                    {/* TODO : Enable these pages */}
                    <Link to='/pmrf-scholars' className="dropdown-item nav-link">PMRF</Link>
                    <Link to='/prime-minister-s-fellowship' className="dropdown-item nav-link">Prime Minister's Fellowship</Link>
                    <Dropdown.Header>Fees</Dropdown.Header>
                    <Link to='/fee-structure' className="dropdown-item nav-link">Fee Structure</Link>
                    <Link to='/statement-of-expenditure' className="dropdown-item nav-link">Statement of Expenditure</Link>
                  </div>
                  <div className='has-border'>
                    <Dropdown.Header>Academic Resources</Dropdown.Header>
                    <Link to='/academic-calender' className="dropdown-item nav-link">Academic Calendar</Link>
                    <Link to='/b-tech-curriculum' className="dropdown-item nav-link">Curriculum</Link>
                    <Link to='/minors' className="dropdown-item nav-link">Minors</Link>
                    <Link to='/syllabus' className="dropdown-item nav-link">Syllabus</Link>
                    <Link to='/btechtimetable' className="dropdown-item nav-link">Time Table (B.Tech)</Link>
                    <Link to='/timetable-pg' className="dropdown-item nav-link">Time Table (PG)</Link>
                    <Link to='/academic-forms' className="dropdown-item nav-link">Forms</Link>
                    <Link to='/ordinances' className="dropdown-item nav-link">Ordinances</Link>
                    <Link to='/academic-services' className="dropdown-item nav-link">Academic Services</Link>
                    <Link to='https://old.iittp.ac.in/moodle' className="dropdown-item nav-link">Moodle</Link>
                    <Link to='/academic-team' className="dropdown-item nav-link">Academic Team</Link>
                    <Link to='https://files.iittp.ac.in/pdfs/btechthesis/IITTirupatiThesisProjectSynopsis.zip' className="dropdown-item nav-link">Project Thesis Template</Link>
                    <Dropdown.Header>Center and Facilities</Dropdown.Header>
                    <Link to='/CentralLibrary' target='_blank' className="dropdown-item nav-link">Central Library</Link>
                    
                  </div>

                </div>
              )}
            </NavDropdown>



            {/**************** 4. Research ***************/}


              <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll"
                onMouseEnter={() => handleMouseEnter("Research")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "Research"}
                title="Research"
              >

              {/* <span className="nav-link">Research</span> */}
              {hoveredDropdown === "Research" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                    <div className='has-border'>
                      <Dropdown.Header>Research</Dropdown.Header>
                      <Link to='https://oia.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">OIA</Link>
                      <Link to='https://iittp.ac.in/iic/' target='_blank' className="dropdown-item nav-link">IIC</Link>
                      <Link to='http://10.21.24.53/' target='_blank' className="dropdown-item nav-link">CSRC Website (Intranet)</Link>
                      <Link to='/research-thrust-areas' className="dropdown-item nav-link">Thrust Areas</Link>
                      <Link to='/research-projects' className="dropdown-item nav-link">Research Projects</Link>
                      <Link to='/research-equipment' className="dropdown-item nav-link">Research Equipment</Link>
                      <Link to='https://files.iittp.ac.in/pdfs/IPR%20Policy.pdf' target='_blank' className="dropdown-item nav-link">IPR Policy</Link>
                      <Link to='/incubation' className="dropdown-item nav-link">Incubation & Entrepreneurship</Link>
                      <Link to='/patent-technology-transfer' className="dropdown-item nav-link">Patent & Technology Transfer</Link>
                      <Link to='https://iittnif.com' target='_blank' className="dropdown-item nav-link">Technology Innovation Hub</Link>
                      {/* <Link to="/coming-soon" className="dropdown-item nav-link">CoE <i className="fas fa-uc"></i></Link> */}
                    </div>
                </div>
              )}
            </NavDropdown>


            {/**************** 5. People ***************/}


              <NavDropdown
                className="align-text-top basic-nav-dropdown"
                onMouseEnter={() => handleMouseEnter("People")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "People"}
                title="People"
              >

              {/* <span className="nav-link">People</span> */}
              {hoveredDropdown === "People" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                  <div className="has-border">
                    <Dropdown.Header>People</Dropdown.Header>
                    <Link to='/chemical-engineering-department' className="dropdown-item nav-link">Faculty</Link>
                    <Link to='/admin-staff' className="dropdown-item nav-link">Staff</Link>
                  </div>
                </div>
              )}
            </NavDropdown>


            {/**************** 6. Campus Life ***************/}


      


              <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll"
                onMouseEnter={() => handleMouseEnter("Campus Life")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "Campus Life"}
                title="Campus Life"
              >

              {/* <span className="nav-link">Campus Life</span> */}
              {hoveredDropdown === "Campus Life" && (
                // <div className="eventsNav  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                <div className="eventsNav ">
                  <div className="has-border" >
                    <Dropdown.Header>Activites</Dropdown.Header>
                    <Link to='/cultural' className="dropdown-item nav-link">Cultural</Link>
                    <Link to='/clubs' className="dropdown-item nav-link">Clubs</Link>
                    <Link to='/festivals' className="dropdown-item nav-link">Festival</Link>
                    <Link to='/219-sports-2' className="dropdown-item nav-link">Sports</Link>
                    <Link to='/220-social' className="dropdown-item nav-link">Social</Link>
                    <Dropdown.Divider />
                    <Link to='https://iittp.ac.in/nss/' target='_blank' className="dropdown-item nav-link">NSS</Link>
                    <Link to='https://iittp.ac.in/medha' target='_blank' className="dropdown-item nav-link">Medha</Link>
                    <Link to='https://iittp.ac.in/spicmacay' target='_blank' className="dropdown-item nav-link">Spic Macay</Link>

                    <Dropdown.Header>Schools</Dropdown.Header>
                    {/* <Link to='/coming-soon' className="dropdown-item nav-link">Kendriya Vidyalaya <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to='/coming-soon' className="dropdown-item nav-link">Little Elly <i className="fas fa-uc"></i></Link> */}
                    <Link to='/creche' className="dropdown-item nav-link">Creche</Link>
                    <Link to='/kvsiittcampus' className="dropdown-item nav-link">KV IIT Tirupati Campus</Link>
                  </div>
                  <div className="has-border" >
                    <Dropdown.Header>Facilities</Dropdown.Header>
                    <Link to='https://iittp.ac.in/CentralLibrary' target='_blank' className="dropdown-item nav-link">Central Library</Link>
                    <Link to='https://cc.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">Computer Center</Link>
                    <Link to='/health-center' className="dropdown-item nav-link">Health Centre</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">CIF <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Central Workshop <i className="fas fa-uc"></i></Link> */}
                    <Link to='https://iittp.ac.in/hostel' target='_blank' className="dropdown-item nav-link">Hostel and Mess Establishment</Link>
                    <Link to='https://cdc.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">Career Development Center</Link>
                    <Link to='https://iittp.ac.in/gcu' target='_blank' className="dropdown-item nav-link">Guidance & Counselling Unit</Link>
                    <Link to='/anti-ragging' className="dropdown-item nav-link">Anti Ragging Committee</Link>
                    <Link to='/internalcomplaintcommittee' className="dropdown-item nav-link">Internal Complaints Committee <br />(Anti Sexual Harrasment)</Link>
                    <Link to='https://files.iittp.ac.in/images/demo/iit/pdfs/2018/StudentsConstitution.pdf' target='_blank' className="dropdown-item nav-link">Students Constitution</Link>
                    <Link to='/help-desk-girl-students' className="dropdown-item nav-link">Help Desk @ Girl Students</Link>
                    <Link to='/transportation' className="dropdown-item nav-link">Trasportation</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Gymkhana <i className="fas fa-uc"></i></Link> */}
                  </div>

                </div>
              )}
            </NavDropdown>


            {/**************** 7. Resources ***************/}


            <NavDropdown
              className="align-text-top basic-nav-dropdown"
              onMouseEnter={() => handleMouseEnter("Resources")}
              onMouseLeave={handleMouseLeave}
              show={hoveredDropdown === "Resources"}
              title="Resources"
            >

              {/* <span className="nav-link">Resources</span> */}
              {hoveredDropdown === "Resources" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                  <div className="has-border">
                    <Dropdown.Header>Quick Links</Dropdown.Header>
                    {/* <Dropdown.Header>Media</Dropdown.Header> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">IITTP Press Release <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">IITTP Media <i className="fas fa-uc"></i></Link> */}
                    <Link to='http://intranet.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">Intranet</Link>
                    <Link to='/infrastructure-at-transit-campus' className="dropdown-item nav-link">Gallery</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Videos <i className="fas fa-uc"></i></Link> */}
                    <Link to='/faqs' className="dropdown-item nav-link">FAQ</Link>
                    <Link to='/publications' className="dropdown-item nav-link">Publications</Link>
                    <Link to='/istem' className="dropdown-item nav-link">I-STEM IIT Tirupati</Link>
                    <Link to='/home-events-list' className="dropdown-item nav-link">Events</Link>
                    <Link to='/technical-talks' className="dropdown-item nav-link">Talks </Link>
                    <Link to='/conferences' className="dropdown-item nav-link">Conference</Link>
                    <Link to='/workshops' className="dropdown-item nav-link">Workshop</Link>

                  </div>
                </div>
              )}
            </NavDropdown>

            {/**************** 8. Recruitment ***************/}
            
              <NavDropdown
                className="align-text-top basic-nav-dropdown"
                onMouseEnter={() => handleMouseEnter("Recruitment")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "Recruitment"}
                title="Careers"
              >

              {/* <span className="nav-link">Recruitment</span> */}
              {hoveredDropdown === "Recruitment" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                  <div className="has-border">
                    <Dropdown.Header>Recruitment</Dropdown.Header>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Prospective Faculty <i className="fas fa-uc"></i></Link> */}
                    <Link to='/facultyrecruitment' className="dropdown-item nav-link">Faculty Positions</Link>
                    <Link to='/recruitment' className="dropdown-item nav-link">Staff Positions </Link>
                    <Link to='/Project_Positions' className="dropdown-item nav-link">Project Positions </Link>
                    <Link to='/announcements' className="dropdown-item nav-link">Outsourced Positions </Link>
                    <Link to='/Interns_and_Apprentice' className="dropdown-item nav-link">Internship and Apprenticeship</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Post-Doctoral Opportunities <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Project Positions <i className="fas fa-uc"></i></Link> */}
                  </div>
                </div>
              )}
            </NavDropdown>

       
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;
